import Tooltip from '@material-ui/core/Tooltip';
import LocalHospitalIcon from '@material-ui/icons/LocalHospital';
import ChipColored from '@sprinx/react-mui-components/ChipColored';
import React from 'react';

const ProductImageDecoratedAdornmentPharmakon: React.FC<{ size: 'medium' | 'small' }> = ({ size }) => {
  return (
    <Tooltip title='Na tuto položku se vztahují restrikce na omezení prodeje'>
      <ChipColored label='VLP' color='#008b3d' size={size} icon={<LocalHospitalIcon />} />
    </Tooltip>
  );
};

export default ProductImageDecoratedAdornmentPharmakon;
